// For color mapping see docs:
// https://getbootstrap.com/docs/5.0/components/badge/#background-colors
export const bsClassForRegistrationStatus = (reg) => {
    switch (reg.registrationStatus) {
        case "CREATED":
            return "bg-primary";
        case "ACTIVE":
            return "bg-success";
        case "PENDING_COMMIT":
            return "bg-warning text-dark";
        case "BLOCKED":
            return "bg-danger";
        case "REMOVED":
            return "bg-secondary";
    }
};
